/* unplugin-vue-components disabled */import { render } from "./DeviceAddress.vue?vue&type=template&id=5fb76f3d&scoped=true"
import script from "./DeviceAddress.vue?vue&type=script&lang=js"
export * from "./DeviceAddress.vue?vue&type=script&lang=js"

import "./DeviceAddress.vue?vue&type=style&index=0&id=5fb76f3d&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb76f3d"]])

export default __exports__